module.exports = __webpack_public_path__ + "img/COMBO RADIO BW.16c3648.svg";